import React from 'react';
import { Code2, Database, Cloud, Settings } from 'lucide-react';

const Technologies = () => {
  const techCategories = [
    {
      icon: <Code2 className="w-8 h-8 text-primary-600" />,
      title: "Programming Languages",
      technologies: [".NET Framework", "Python", "JavaScript", "TypeScript"],
      color: "bg-blue-50 border-blue-200"
    },
    {
      icon: <Cloud className="w-8 h-8 text-green-600" />,
      title: "Cloud Platforms",
      technologies: ["AWS", "Azure", "GCP"],
      color: "bg-green-50 border-green-200"
    },
    {
      icon: <Settings className="w-8 h-8 text-purple-600" />,
      title: "DevOps & Infrastructure",
      technologies: ["Terraform", "AWS CDK", "Azure DevOps"],
      color: "bg-purple-50 border-purple-200"
    }
  ];

  return (
    <section id="technologies" className="section-padding bg-white">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary-900 mb-4">
            Technology Stack
          </h2>
          <p className="text-xl text-secondary-600 max-w-3xl mx-auto">
            We leverage cutting-edge technologies and industry best practices to 
            deliver robust, scalable, and efficient solutions.
          </p>
        </div>

        {/* Technology Categories */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {techCategories.map((category, index) => (
            <div 
              key={index}
              className={`${category.color} border-2 rounded-2xl p-8 hover:shadow-lg transition-all duration-300`}
            >
              <div className="mb-6">
                {category.icon}
              </div>
              <h3 className="text-xl font-bold text-secondary-900 mb-6">
                {category.title}
              </h3>
              <div className="space-y-3">
                {category.technologies.map((tech, techIndex) => (
                  <div 
                    key={techIndex}
                    className="bg-white px-4 py-2 rounded-lg text-secondary-700 font-medium shadow-sm"
                  >
                    {tech}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Technology Grid - All Technologies */}
        <div className="bg-secondary-50 rounded-2xl p-8 md:p-12">
          <h3 className="text-2xl md:text-3xl font-bold text-secondary-900 mb-8 text-center">
            Our Complete Technology Arsenal
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {[
              ".NET", "Python", "JavaScript", "TypeScript", "AWS", "Azure", 
              "GCP", "Terraform", "CDK", "DevOps", "Docker", "Kubernetes",
              "React", "Angular", "Node.js", "SQL Server", "PostgreSQL", "MongoDB"
            ].map((tech, index) => (
              <div 
                key={index}
                className="bg-white px-4 py-3 rounded-lg text-center text-secondary-700 font-medium shadow-sm hover:shadow-md transition-shadow duration-200"
              >
                {tech}
              </div>
            ))}
          </div>
        </div>

        {/* Technology Benefits */}
        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Database className="w-8 h-8 text-primary-600" />
            </div>
            <h4 className="text-xl font-bold text-secondary-900 mb-3">
              Modern & Scalable
            </h4>
            <p className="text-secondary-600">
              We use the latest technologies that can scale with your business growth.
            </p>
          </div>
          <div className="text-center">
            <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Settings className="w-8 h-8 text-primary-600" />
            </div>
            <h4 className="text-xl font-bold text-secondary-900 mb-3">
              Industry Standard
            </h4>
            <p className="text-secondary-600">
              Our technology choices follow industry best practices and standards.
            </p>
          </div>
          <div className="text-center">
            <div className="bg-primary-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Cloud className="w-8 h-8 text-primary-600" />
            </div>
            <h4 className="text-xl font-bold text-secondary-900 mb-3">
              Cloud Native
            </h4>
            <p className="text-secondary-600">
              Built for the cloud with security, reliability, and performance in mind.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technologies;
